import {
  Form
} from 'element-ui'
import global from "../../utils/global"

// Form 表单 labelwidth 默认值
Form.props.labelWidth = {
  type: String,
  default: global.form.labelWidth
}
